import React, { createContext, useContext, useEffect, useState } from 'react';

// ─── Deploy switch ───────────────────────────────────────────────────────────
// Change this one constant to 'dark' before deploying the dark version.
// User preference (localStorage) always overrides this default.
const DEFAULT_THEME = 'light';
// ─────────────────────────────────────────────────────────────────────────────

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        return DEFAULT_THEME;
    });

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        try {
            localStorage.setItem('ey-theme', theme);
        } catch { /* ignore */ }
    }, [theme]);

    const toggle = () => setTheme(t => (t === 'light' ? 'dark' : 'light'));

    return (
        <ThemeContext.Provider value={{ theme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
